import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Permissions } from 'src/app/core/common';
import { UserPermissionService } from 'src/app/core/services/user-permission-service';
import { RoutesConstants } from '../common';

@Injectable({
    providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
    constructor(private userPermissionService: UserPermissionService, private router: Router) { }

    canActivate(next: ActivatedRouteSnapshot): boolean {
        const permissions = next.data['permissions'] as Array<Permissions>;
        if (!permissions) {
            return true;
        }
        let isUserHasPermission = false;
        isUserHasPermission = this.userPermissionService.isHasPermission(permissions);
        if (!isUserHasPermission) {
          this.router.navigate(['not-have-permission']);
        }
        return isUserHasPermission;
    }
}
